/** Brand primary blue, used for CTA buttons and active states. */
export const PRIMARY_BLUE = "#2596fa"

/** Hover variant of `PRIMARY_BLUE`. */
export const PRIMARY_BLUE_HOVER = "#1e7cd8"

/** Secondary text color, used for labels, captions, and muted content. */
export const TEXT_SECONDARY = "#5f6774"

/** Primary neutral text color (near-black), used for headings and body text on light backgrounds. */
export const TEXT_PRIMARY = "#171717"

/** Near-black with a slight brown tint, used for dialog headings. */
export const TEXT_HEADING = "#201f1f"

/** Softer near-black, used for dialog body copy. */
export const TEXT_BODY = "#3e3e3e"

/** Muted gray text, used for captions, meta info, and disabled labels. */
export const TEXT_MUTED = "#9ca3af"

/** Medium gray text, used for low-emphasis button labels. */
export const TEXT_SOFT = "#8d8d8d"

/** Tailwind gray-300, used for dividers, pipes, and disabled surface borders. */
export const BORDER_MUTED = "#d1d5db"

/** Very soft off-white divider, used for in-card section separators. */
export const BORDER_SUBTLE = "#f4f4f4"

/** Light border color, used for card and container dividers. */
export const BORDER_LIGHT = "#e5e7eb"

/** Very light background, used for page backgrounds and subtle section fills. */
export const BG_VERY_LIGHT = "#f5f7f9"

/** Near-white footer background, used on venue contact footer block. */
export const BG_OFF_WHITE = "#fcfcfd"

/** Input border color, used for outlined text field and form element borders. */
export const BORDER_INPUT = "#f1f2f5"

/** Grid line / tick mark color in horizontal schedule. */
export const GRID_LINE = "#e5e6ec"

/** MUI default primary blue, used for icon accents that follow MUI's theme primary colour. */
export const PRIMARY_BLUE_MUI = "#1976d2"

/** Dark top bar background, used on public pages. */
export const BG_DARK = "#171717"

/** Pure black, used as base for dropdown menu surfaces on dark top bar. */
export const BG_BLACK = "#000000"

/** Dark menu hover background. */
export const BG_DARK_HOVER = "#1f1f1f"

/** Dark menu selected background. */
export const BG_DARK_SELECTED = "#262626"

/** Dark menu selected-hover background. */
export const BG_DARK_SELECTED_HOVER = "#2d2d2d"

/** Border for dark dropdown menu surfaces. */
export const BORDER_DARK = "#3b3b3b"
